/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersProfileWebimQueryResponse, GetUsersProfileWebim400 } from '../entities/GetUsersProfileWebim'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetUsersProfileWebimUrl() {
  return `/users/profile/webim` as const
}

/**
 * @description Получение авторизованного посетителя для Webim
 * @summary Get Webim Visitor
 * {@link /users/profile/webim}
 */
export async function getUsersProfileWebim(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetUsersProfileWebimQueryResponse, ResponseErrorConfig<GetUsersProfileWebim400>, unknown>({
    method: 'GET',
    url: getGetUsersProfileWebimUrl().toString(),
    ...requestConfig,
  })
  return res.data
}